let baseUtil = {
        deepClone (source){
            if(!source&&typeof source!='object'){
                throw new Error('error agruments','deepClone')
            }
            const targetObj =source.constructor ===Array?[]:{}
            Object.keys(source).forEach(keys=>{
                if(source[keys]&& typeof source[keys]==='object'){
                    targetObj[keys]=this.deepClone(source[keys])
                }else{
                    targetObj[keys]=source[keys]
                }
            })
            return targetObj
        }

}

export default baseUtil;